// Author Eric
// Date 2021-05-08 17:11:04

class SithMesMstLocalStorage {
constructor({
        id = null,
        realName = '',
        name = '',
        suffix = '',
        path = '',
        type = '',
        size = '',
        remark = ''}
= {}) {
    this.id = id;
    this.realName = realName;
    this.name = name;
    this.suffix = suffix;
    this.path = path;
    this.type = type;
    this.size = size;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstLocalStorage();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstLocalStorage.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'suffix',
        label: 'label.sith.mst.sithMesMstLocalStorage.grid.suffix',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'path',
        label: 'label.sith.mst.sithMesMstLocalStorage.grid.path',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'size',
        label: 'label.sith.mst.sithMesMstLocalStorage.grid.size',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstLocalStorage.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    realNameFilter : "",
    nameFilter : "",
    suffixFilter : "",
    pathFilter : "",
    typeFilter : "",
    sizeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.mst.sithMesMstLocalStorage.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'suffixFilter',
        label: 'label.sith.mst.sithMesMstLocalStorage.filter.suffix',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sizeFilter',
        label: 'label.sith.mst.sithMesMstLocalStorage.filter.size',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstLocalStorage.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'suffix',
        label: 'label.sith.mst.sithMesMstLocalStorage.entity.suffix',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'path',
        label: 'label.sith.mst.sithMesMstLocalStorage.entity.path',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'size',
        label: 'label.sith.mst.sithMesMstLocalStorage.entity.size',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstLocalStorage.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstLocalStorage, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
